export default __webpack_public_path__ + "static/media/Blackmarrow Chest.341c8a65.jpg";